import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { errMsg } from "../lib/api";
import { AnimatedEmblem } from "../components/shop/AnimatedEmblem";
import { TwoFactorLogin } from "./SecurityPages";
import { TrustRow } from "../components/security/TwoFactor";

export default function AuthPage({ mode }) {
  const isLogin = mode === "login";
  const { login, register } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [challenge, setChallenge] = useState(null);
  const go = (u) => nav(u.role === "admin" ? "/admin" : u.onboarded ? "/member" : "/join");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = isLogin ? await login(form.email, form.password) : await register(form);
      if (u.twofa_required) setChallenge(u); else go(u);
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };
  const input = (k, type = "text") => (
    <label className="block"><span className="text-xs text-[#707783]">{t(k)}</span>
      <input data-testid={`auth-${k}-input`} type={type} required minLength={k === "password" ? 8 : undefined} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
        className="mt-1 w-full rounded-xl border border-[#120E1F]/10 bg-white px-4 py-3 text-sm focus:outline-none focus:border-[#F2C230] transition-colors" /></label>
  );

  if (challenge) return (
    <div className="bg-[#F7F5FB] min-h-[75vh] grid place-items-center px-4 py-16">
      <div className="w-full max-w-md bg-white rounded-[28px] border border-[#120E1F]/5 p-8 sm:p-10 space-y-5 shadow-[0_30px_60px_-30px_rgba(18,14,31,0.2)]">
        <AnimatedEmblem className="h-16 w-16" testid="twofa-emblem" />
        <TwoFactorLogin challenge={challenge} onDone={go} onCancel={() => setChallenge(null)} />
        <TrustRow />
      </div>
    </div>
  );
  return (
    <div className="bg-[#F7F5FB] min-h-[75vh] grid place-items-center px-4 py-16">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-[28px] border border-[#120E1F]/5 p-8 sm:p-10 space-y-5 shadow-[0_30px_60px_-30px_rgba(18,14,31,0.2)]" data-testid={`${mode}-form`}>
        <AnimatedEmblem className="h-16 w-16" testid="auth-emblem" />
        <div><h1 className="font-display text-4xl text-[#120E1F]">{t(isLogin ? "login_title" : "register_title")}</h1>
          {!isLogin && <p className="text-sm text-[#707783] mt-1">{t("register_sub")}</p>}</div>
        {!isLogin && input("name")}
        {input("email", "email")}
        {input("password", "password")}
        {isLogin && <Link to="/forgot-password" className="block text-right text-xs text-[#6E3FB8] underline underline-offset-4 -mt-2" data-testid="forgot-password-link">{t("forgot_pw")}</Link>}
        <button type="submit" disabled={loading} data-testid="auth-submit-btn" className="btn-dark w-full h-12">{t(isLogin ? "login" : "register")}</button>
        <p className="text-sm text-center text-[#707783]">{t(isLogin ? "no_account" : "have_account")}{" "}
          <Link to={isLogin ? "/join" : "/login"} data-testid="auth-switch-link" className="text-[#120E1F] font-semibold underline decoration-[#F2C230] underline-offset-4">{t(isLogin ? "register" : "login")}</Link></p>
        <TrustRow />
      </form>
    </div>
  );
}
